module.exports = __webpack_public_path__ + "assets/img/company.df8145f2.png";